import { render } from "./AddEditBuyingGroup.vue?vue&type=template&id=20095d3f"
import script from "./AddEditBuyingGroup.vue?vue&type=script&lang=js"
export * from "./AddEditBuyingGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__